import styled, { css } from 'styled-components';
import Button from '@prisjakt/ui-button';

export const SwitchButton = styled(Button)`
  position: absolute;
  top: 40%;
  background: ${p => p.theme.buttons.panning.bg};
  z-index: 1;
  opacity: 0;
  transition: opacity 0.5s;
  color: ${p => p.theme.buttons.panning.text};

  && {
    svg {
      path {
        fill: ${p => p.theme.buttons.panning.text};
      }
    }
  }

  &&:hover,
  &&:focus {
    background: ${p => p.theme.buttons.panning.bgHover};
  }
`;

export const CarouselWrapper = styled.div.attrs({ 'data-test': 'Carousel' })`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  position: relative;
  outline: 0;

  &:hover {
    ${SwitchButton} {
      opacity: 1;
    }
  }

  &--current,
  &--prev,
  &--next {
    display: flex;
    flex: 0 0 100%;
    justify-content: center;
    align-items: center;

    > * {
      max-height: inherit;
      max-width: 100%;
      width: auto;
    }

    &-animate-left {
      transform: translate3d(100%, 0, 0);
    }

    &-animate-right {
      transform: translate3d(-100%, 0, 0);
    }
  }
`;

export const CarouselSlide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > * {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 100%;
    max-width: 100%;
    width: auto;
    min-width: 1px;
  }
`;

export const CarouselSlideContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IndicatorWrapper = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 10px;
`;

export const ThumbnailWrapper = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  padding-top: 25px;
`;

interface ISelectable {
  selected: boolean;
}

export const Thumbnail = styled.span<ISelectable>`
  cursor: pointer;
  width: 80px;
  display: inline-block;
  margin: 3px;
  border: 1px solid transparent;
  ${p =>
    p.selected &&
    css`
      border-color: ${p.theme.colors.base0};
    `}

  img {
    height: 80px;
  }
`;

export const Indicator = styled.button<ISelectable>`
  cursor: pointer;
  height: 10px;
  width: 10px;
  margin: 5px;
  display: inline-block;
  background-color: transparent;
  border: 1px solid ${p => p.theme.colors.base500};
  border-radius: 50%;
  ${p =>
    p.selected &&
    css`
      background-color: ${p.theme.colors.base500};
    `}
`;
